import React, { memo } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

const FilterItem = ({ onSelectFilter, cabinType, isSelected, value }) => {
  const handleClick = () => {
    onSelectFilter(cabinType);
  };

  return (
    <button
      type="button"
      className={clsx(
        'sm:py-4 py-2 px-2 w-30 text-center rounded-2xl focus:outline-none capitalize',
        isSelected && 'text-white bg-button-theme',
      )}
      value={cabinType}
      onClick={handleClick}
    >
      {cabinType}
      {value ? (
        <>
          {' '}
          ({value}
          +)
        </>
      ) : (
        <></>
      )}
    </button>
  );
};

FilterItem.propTypes = {
  onSelectFilter: PropTypes.func.isRequired,
  cabinType: PropTypes.string.isRequired,
  isSelected: PropTypes.bool.isRequired,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.node]).isRequired,
};

export default memo(FilterItem);
